import { Injectable, Input } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { INotification } from '../components/notification/notification.interface';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private readonly notificationSubject = new BehaviorSubject<INotification>(null);
  currentNotification = this.notificationSubject.asObservable();
  autoHideDuration = 12000;
  timeout: any;
  currentRoute: any;

  constructor(private router: Router) { 
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.currentRoute = e.url;
      }
    });
  }

  error(message: INotification['message'], autoHide?: boolean) {
    let excludeErrorMessage = false;
    for (const singleMessage of message) {
      if (
        singleMessage === 'Password does not match with existing password.' ||
        singleMessage === 'Password is the same as your current password, please change it.' ||
        singleMessage === 'Password has been used already, please choose another.' ||
        singleMessage === 'Incorrect user credentials, log in failed.' ||
        singleMessage === 'You are not authorized to perform the task.' ||
        singleMessage === 'You are not authorised to perform this operation.' ||
        singleMessage === 'No Plan has been created.' ||
        singleMessage.includes('Please check question no') ||
        ((singleMessage === 'Record not found.') && (this.currentRoute == '/care-plan'))
      ) {
        excludeErrorMessage = true;
      }
    }
    if (!excludeErrorMessage) {
      this.notify('error', message, autoHide);
    }
  }

  success(message: INotification['message'], autoHide?: boolean) {
    this.notify('success', message, autoHide);
  }

  close() {
    this.notificationSubject.next(null);
  }

  private notify(type: INotification['type'], message: INotification['message'], autoHide?: boolean) {

    const notification: INotification = {
      message,
      type
    };

    this.notificationSubject.next(notification);
    if (autoHide) {
      setTimeout(() => this.close(), this.autoHideDuration);
    }
    
  }
}
